<template>
  <transition name="drop-down">
    <div class="dropdown" v-if="isDropdown">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "dropdown-desktop",
  props: {
    isDropdown: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.drop-down-enter-active,
.drop-down-leave-active {
  transition: transform 0.4s ease-in-out;
}
.drop-down-enter,
.drop-down-leave-to {
  transform: translateY(-1200px);
}
.dropdown {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 20;
  height: auto;
  webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
</style>
